import { createGlobalStyle } from 'styled-components'

import { theme } from './theme'
import './reset.css'
import './fonts.css'

export const GlobalStyles = createGlobalStyle`
  ::-webkit-scrollbar {
    width: 4px;
    height: 4px;
  }

  ::-webkit-scrollbar-thumb {
    background-color: ${theme.palette.blue};
    border-radius: 8px;
  }
 
  ::-webkit-scrollbar-track {
    background-color: transparent;
  }

  @supports(scrollbar-width: thin) {
    * {
      scrollbar-width: thin;
      scrollbar-color: white transparent;
    }
  }

  body {
    font-family: ${theme.fontFamily}, sans-serif;
    color: black;
    background-color: white;

    overflow: hidden;
    overflow-y: auto;

    &.m-show-modal {
      overflow-y: hidden;
    }
  }

  #root {
    display: flex;
    width: 100vw;
    flex-direction: column;
    align-items: center;
    position: relative;
  }

  .blur {
    filter: blur(12px);
  }

  .overflow-hidden{
    overflow: hidden;
  }

  b,
  strong {
    font-weight: 700;
  }
`
